import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { BugTracker } from './app/services/bug-tracker';
import { MarkerTracker } from './app/services/marker-tracker';
import { applyEnvironmentFavicon } from './app/shared/utils/favicon';

applyEnvironmentFavicon();
BugTracker.init();
MarkerTracker.init();
platformBrowser()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

// test for branch-all
